// |String| Check if a string ends with a character
// Source: http://stackoverflow.com/a/646643/179015 */

function endsWith(str, test) { 
    return str.slice(-test.length) == test; 
};

export default endsWith;

